import $ from 'jquery'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'

imagesLoaded.makeJQueryPlugin($)

let iso = ''

const parent = $('.pt-advices__posts')
if (parent.length) {
  iso = new Isotope('.pt-advices__posts', {
    itemSelector: '.feed-advice',
    percentPosition: true,
    masonry: {
      columnWidth: '.pt-advices__sizer',
    },
  })

  parent.imagesLoaded(function () {
    iso.layout()
  })

  $('.pt-advices__filter').on('change', function () {
    const all = $('.pt-advices__filter')
    const vals = []

    all.each(function () {
      if ($(this).prop('checked')) {
        vals.push($(this).val() * 1)
      }
    })

    if (vals.length === 0) {
      iso.arrange({ filter: '*' })
      return
    }

    iso.arrange({
      filter: function () {
        const advice = $(this)

        if (advice.hasClass('pt-advices__sizer')) {
          return false
        }

        const attr = advice.attr('data-categories')
        const categories = attr.includes(',') ? attr.split(',') : [attr]
        const newCategories = categories.map(Number)
        let has = false

        if (newCategories.length > 0) {
          for (let i = 0; i < vals.length; i++) {
            if (newCategories.includes(vals[i])) {
              has = true
            }
          }
        }

        return has
      },
    })
  })
}

$('.pt-advices__filter-btn').on('click', function () {
  $('.pt-advices__sidebar').toggleClass('active')
})
